import { useState } from 'react';
import ComplianceSelectBox from './ComplianceSelectBox';
import VehicleAndTrailerForm from '../ui/VeichleAndTrailerForm';
import { COMPLIANCE_STATUS } from '../../constants/constant';

type VeichleComplianceCardProps = {
  compliance?: string;
  category: string;
  status: string;
  allocatedTo: string;
  nextComplianceDateDisplay?: string;
  complianceDescription?: string;
  isEditable?: boolean;
  allocatedStaffId?: number;
  onStaffChange?: (staffId: number) => void;
  recurrency?: string;
  lastComplianceDateDisplay?: string;
  nextComplianceDate?: string;
  name?: string;
  note?: string;
  closeModal: () => void;
  complianceId?: number;
  equipmentId?: number;
  equipmentTypeId?: number;
  refetchComplianceDetails: () => void;
  complianceCategoryDescription?: string;
  editPermissionForVeichleCompliance?: boolean;
  upcomingDays?: number;
};

export default function VeichleComplianceCard({
  nextComplianceDate,

  note,
  equipmentTypeId,
  equipmentId,
  complianceId,
  compliance,
  category,
  status,
  allocatedTo,
  nextComplianceDateDisplay,
  complianceDescription,
  isEditable = false,
  allocatedStaffId,
  onStaffChange,
  recurrency,
  lastComplianceDateDisplay,
  refetchComplianceDetails,
  complianceCategoryDescription,
  editPermissionForVeichleCompliance,
  upcomingDays,
}: VeichleComplianceCardProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCloseModal = () => setIsModalOpen(false);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-6 gap-x-6 text-start text-sm">
      <div className="flex flex-col">
        <p className="font-medium text-textColorGray">Future Task</p>
        <p className="text-text-black">{category}</p>
      </div>
      <div className="flex flex-col">
        <p className="font-medium text-textColorGray">Compliance</p>
        <p className="text-text-black">{complianceDescription}</p>
      </div>
      <div className="flex flex-col">
        <p className="font-medium text-textColorGray">Category</p>
        <p className="text-text-black">{complianceCategoryDescription}</p>
      </div>
      <div onClick={() => setIsModalOpen(true)} className="flex flex-col">
        <p className="font-medium text-textColorGray">Status</p>
        <p
          className={`${
            editPermissionForVeichleCompliance ? 'underline decoration-2' : ''
          } ${
            (upcomingDays ?? 0) <= 7
              ? 'text-red-500'
              : (upcomingDays ?? 0) <= 30
                ? 'text-yellow-500'
                : 'text-gray-700'
          }`}
        >
          {nextComplianceDateDisplay}
        </p>
      </div>

      <div className="flex flex-col w-[70%] mt-4">
        <label className="block text-sm font-medium text-textColorGray text-start">
          Allocated to
        </label>
        <ComplianceSelectBox
          allocatedTo={allocatedTo}
          disabled={!isEditable}
          allocatedStaffId={allocatedStaffId}
          onChange={(e) => {
            onStaffChange?.(Number(e.target.value));
          }}
          isEditMode={isEditable}
        />
      </div>
      {isModalOpen && editPermissionForVeichleCompliance && (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center px-4">
          <VehicleAndTrailerForm
            compliance={compliance}
            name={allocatedTo}
            category={category}
            recurrency={recurrency}
            status={nextComplianceDateDisplay}
            closeModal={handleCloseModal}
            equipmentId={equipmentId}
            complianceId={complianceId}
            note={note}
            equipmentTypeId={equipmentTypeId}
            nextComplianceDate={nextComplianceDate}
            lastComplianceDateDisplay={lastComplianceDateDisplay}
            onSubmitSuccess={refetchComplianceDetails}
          />
        </div>
      )}
    </div>
  );
}
